(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-category-list"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".giftSwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        550: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-category-list"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        550: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-tab"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  const tabButtons = document.querySelectorAll('.meta-tab-btn');
  const items = document.querySelectorAll('.meta-item');
  const headers = document.querySelectorAll('.accordion-header');

  /* ===== DESKTOP TABS ===== */
  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;

      tabButtons.forEach(b => b.classList.remove('active'));
      items.forEach(i => i.classList.remove('active'));

      btn.classList.add('active');
      document.getElementById('tab-' + tab).classList.add('active');
    });
  });

  /* ===== MOBILE ACCORDION ===== */
  headers.forEach(header => {
    header.addEventListener('click', () => {
      if (window.innerWidth > 767) return;

      const parent = header.closest('.meta-item');
      const isOpen = parent.classList.contains('active');

      items.forEach(i => i.classList.remove('active'));
      if (!isOpen) parent.classList.add('active');
    });
  });

});


  } catch(e) { console.error(e); }
})();
})();
